export default __webpack_public_path__ + "static/media/icon-video-transcript_teal.23dd3dc3.svg";